<template>
	<db-row class="tabs-wrapper ovh" :height="height">
		<template v-if="dir == TabsDirTypes.HORI">
			<!-- 处理Tab的头部，支持开发者自定义头部dom结构 -->
			<db-col height="auto" class="tab-header-case ovh" v-if="headers.length > 0" :style="headStyle">
				<template v-if="$scopedSlots.customer">
					<db-scroller dir="hori">
						<db-col width="auto" @click="swipeTo(idx, item)" v-for="(item, idx) in headers" :key="idx" class="tab-title" :class="'tab-title--' + (idx == currIndex)" align="center">
							<slot name="customer" :data="item" />
						</db-col>
					</db-scroller>
				</template>
				<template v-else>
					<db-scroller dir="hori">
						<db-col width="auto" @click="swipeTo(idx, item)" v-for="(item, idx) in headers" :key="idx" class="tab-title" :class="'tab-title--' + (idx == currIndex)" align="center">
							{{item.title}}
							<db-col height="6" width="40" class="curr-bar" v-if="idx == currIndex"></db-col>
						</db-col>
					</db-scroller>
				</template>
			</db-col>
			<db-swipe ref="tabSwiper" :autoplay="0" :touchable="touchable" :loop="false" @change="swipeChange">
				<db-row v-for="(item, idx) in swipeItems" :key="idx" :slot="'swipe-slot-' + idx">
					<slot :name="item.slotName" v-if="currIndex == idx" />
				</db-row>
			</db-swipe>
		</template>
	</db-row>
</template>

<script>
	import {TabsDirTypes} from '../../../enum'
	
	export default {
		name: 'tabs_',
		
		inject: ['refresh'],
		
		props: {
			height: {
				type: [String, Number],
				default: 'auto'
			},
			
			touchable: {
				type: Boolean,
				default: true
			},
			
			dir: {
				type: String,
				default: TabsDirTypes.HORI
			},
			
			headerHeight: {
				type: [String, Number],
				default: '120'
			}
		},
		
		data(){
			return {
				currIndex: 0,
				TabsDirTypes,
				swipeItems: this.getItems(),
				headStyle: {
					minHeight: parseFloat(this.headerHeight / 75) + 'rem'
				}
			}
		},
		
		mounted(){
			Object.keys(this.$slots).filter(slotName => slotName.includes('tab-slot-')).map((slotName, idx) => {
				const {data: {attrs}} = this.$slots[slotName][0]
				if(attrs.selected != undefined){
					this.currIndex = idx
					this.swipeTo(this.currIndex)
				}
			})
			setTimeout(() => {
				this.refresh && this.refresh()
			}, 500)
		},
	
		computed: {
			/* swipeItems(){
				return Object.keys(this.$slots).filter(slotName => slotName.includes('tab-slot-')).map((slotName, idx) => {
					const {data: {attrs}} = this.$slots[slotName][0]
					return {
						slotName,
						...attrs
					}
				})
			}, */
			
			headers(){
				return this.swipeItems.filter(item => !!item.title)
			}
		},
		
		methods: {
			getItems(){
				return Object.keys(this.$slots).filter(slotName => slotName.includes('tab-slot-')).map((slotName, idx) => {
					const {data: {attrs}} = this.$slots[slotName][0]
					return {
						slotName,
						...attrs
					}
				})
			},
			
			swipeChange(idx){
				this.currIndex = idx
				this.$emit('change', idx)
				
				setTimeout(() => {
					this.refresh && this.refresh()
				}, 500)
			},
			
			swipeTo(idx, item){
				this.$refs.tabSwiper.swipeTo(idx)
				this.$emit('input', item.name)
			},
			
			prev(handler){
				this.$refs.tabSwiper.prev()
				if(handler){
					setTimeout(() => {
						handler()
					}, 300)
				}
			},
			
			next(handler){
				this.$refs.tabSwiper.next()
				if(handler){
					setTimeout(() => {
						handler()
					}, 300)
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.tabs-wrapper{
		
		.tab-header-case{
			min-height: 120px;
		}
	}
	
	.tab-title{
		position: relative;
		padding: 0 24px;
		font-size: 32px;
		color: #999;
		font-weight: bold;
	}
	
	.tab-title--true{
		color: #333;
	}
	
	.curr-bar{
		position: absolute;
		left: 50%;
		bottom: 0;
		background: #333;
		margin-left: -20px;
	}
</style>
